<template>
  <form
    @submit.prevent="submit"
    class="product-checkout-form-buy col mt-9 mt-lg-0"
  >
    <div class="my-6">Opções do formulário</div>

    <div class="pl-5">
      <div class="form-group">
        <b-form-checkbox v-model="form.request_address_shopper">
          <span class="text">Solicitar endereço do comprador</span>
        </b-form-checkbox>
      </div>

      <!-- <div class="form-group">
      <b-form-checkbox v-model="form.request_cpf_cnpj_shopper">
        Solicitar o CPF/CNPJ do comprador
      </b-form-checkbox>
    </div> -->

      <div class="form-group">
        <b-form-checkbox v-model="form.request_phone_shopper">
          <span class="text">Solicitar telefone do comprador</span>
        </b-form-checkbox>
      </div>

      <!-- <div class="form-group">
      <b-form-checkbox v-model="form.coupon_shopper">
        Inserir cupom de desconto
      </b-form-checkbox>
    </div> -->

      <div class="form-group">
        <b-form-checkbox v-model="form.instagram_shopper">
          <span class="text">Solicitar usuário do Instagram do comprador</span>
          <br />
          <small class="text-secondary">
            (Recomendado para produtos vendidos pelo Instagram)
          </small>
        </b-form-checkbox>
      </div>

      <div class="form-group">
        <b-form-checkbox v-model="form.request_zip_code">
          <span class="text"
            >Exigir que o endereço seja preenchido somente com base no CEP</span
          >
          <br />
          <small class="text-secondary"
            >(Atenção! Esta opção pode reduzir a sua conversão)</small
          >
        </b-form-checkbox>
      </div>
    </div>

    <!-- <h6 class="mt-9">Pós-compra</h6>

    <div class="form-group">
      <b-form-checkbox v-model="form.pos_address_shopper">
        Solicitar <strong>endereço</strong> do comprador após a compra caso não
        tenha preenchido
      </b-form-checkbox>
    </div> -->

    <div class="d-sm-flex d-none justify-content-between mt-9">
      <button
        type="button"
        class="btn btn-outline-secondary d-flex align-items-center"
        @click="$emit('cancel')"
      >
        <i class="icon-angle-left mr-3" />
        Voltar
      </button>
      <div class="mx-3"></div>
      <button type="submit" class="btn d-flex align-items-center btn-primary">
        <loading :show="loading">
          Próximo
        </loading>
        <i class="icon-angle-right ml-3" />
      </button>
    </div>
    <div class="d-sm-none justify-content-between mt-9">
      <button
        type="submit"
        class="btn btn-block align-items-center btn-primary"
      >
        <loading :show="loading">
          Próximo
        </loading>
        <i class="icon-angle-right ml-3" />
      </button>
      <div class="m-3"></div>
      <button
        type="button"
        class="btn btn-block btn-outline-secondary align-items-center"
        @click="$emit('cancel')"
      >
        <i class="icon-angle-left mr-3" />
        Voltar
      </button>
    </div>
  </form>
</template>

<script>
import { formFields } from "@/functions/helpers.js";

export default {
  props: {
    optionForm: {
      type: Object,
      default: null
    }
  },
  data() {
    return {
      loading: false,
      ...formFields(
        [
          "request_address_shopper",
          "request_cpf_cnpj_shopper",
          "request_phone_shopper",
          "coupon_shopper",
          "instagram_shopper",
          "request_zip_code",
          "pos_address_shopper"
        ],
        {
          request_address_shopper: false,
          request_cpf_cnpj_shopper: true,
          request_phone_shopper: false,
          coupon_shopper: false,
          instagram_shopper: false,
          request_zip_code: false,
          pos_address_shopper: false,
          ...(this.optionForm ? this.optionForm : {})
        }
      )
    };
  },
  methods: {
    submit() {
      this.$emit("save", this.form);
    }
  }
};
</script>

<style lang="scss" scoped>
.product-checkout-form-buy {
  .form-group {
    margin: 8px 0 0;
  }

  .icon-angle-right,
  .icon-angle-left {
    font-size: 24px;
    margin-bottom: 3px;
  }

  .text {
    color: #5a5466;
    font-size: 14px;
    font-weight: 400;
  }
}
</style>
